import React, { Component } from 'react';
import { connect } from 'react-redux';
import classnames from 'classnames';
import enhanceWithClickOutside from 'react-click-outside';
import { reopenTab, reActivateTab } from '../actions/call';
import SetBusinessOutcome from './modals/setBusinessOutcome';
import SetTagsModal from './modals/setTagsModal';
import RescheduleCall from './modals/RescheduleCall';
import moment from 'moment-timezone'
import AssignToAnotherService from './modals/AssignToAnotherService';
import "../agent/Styles/darktheme.css";
import "../agent/Styles/blacktheme.css";
import "../agent/Styles/highContrast.css";
import record from "../assets/img/record.svg";
import Recording from './modals/Recording';
import {getRecording} from "../actions/getAgentConfig";
import { IoIosPricetags } from "react-icons/io";

class CallMenu extends Component {
	constructor(props) {
		super(props);
		this.state = {
			isShow: false,
			showSetBusinessOutcomeModal: false,
			showRescheduleCallModal: false,
			showAssignToAnotherServiceModal: false,
			showRecordingModal: false,
			showTagsModal: false
		};
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.closeMenu !== this.props.closeMenu && this.state.isShow) {
			this.handleClickOutside();
		}
	}
	

	close = (key) => {
		this.setState({ [key]: false });
	}

	open = (key) => {
		const isInValidServiceId = this.props.serviceId === 0;
		if (
            // (key === 'showAssignToAnotherServiceModal' || key == 'showRescheduleCallModal') || 
            // ((key === 'showTagsModal' ) && !isInValidServiceId) ||

            (key === 'showAssignToAnotherServiceModal' || 
             key == 'showRescheduleCallModal' || 
             key === 'showTagsModal') ||

		    ((key === 'showSetBusinessOutcomeModal' ) && !isInValidServiceId)) 
	    {
			this.setState({ [key]: true });
		}
		if(key === 'showRecordingModal') 
		{
          this.props.getRecording(this.props.CallId).then((response) => {
            this.recordingUrl =
              response &&
              response.data &&
              response.data.response &&
              response.data.response.items &&
              response.data.response.items[0] &&
              response.data.response.items[0].recording &&
              response.data.response.items[0].recording[0]
            ? response.data.response.items[0].recording[0]
            : null;
        this.setState({ [key]: true });
      });
		}
	}

	handleClickOutside = () => {
		if (this.state.isShow) {
			this.setState({
				isShow: !this.state.isShow
			})
		}
	}

	handleClick = () => {
		this.setState(function (prevState) {
			return { isShow: !prevState.isShow };
		});
	}

	reopenTab = () => {
		const {
			agentInfo,
			CallId,
			disableOptions,
			endBusinessId,
			has_tags,
			events,
			phoneNumber,
			scheduleDate,
			scheduleService,
			serviceId,
			type,
			listDetailId
		} = this.props;

		// if(!disableOptions){
		const tab = events.find(item => item.data.id === CallId);
		const data = {
			data: {
				type: type == 'outgoing' ? 'outgoing' : 'incoming',
				id: CallId,
				from: type == 'outgoing' ? agentInfo.extension : phoneNumber,
				to: type == 'outgoing' ? phoneNumber : agentInfo.extension,
				service_id: serviceId,
				timestamp: moment().unix(),
				end_business_id: endBusinessId,
				schedule_date: scheduleDate,
				schedule_service: scheduleService,
				list_detail_id: listDetailId,
				has_tags: has_tags
			},
			tag: `reopen_tab_${type}`
		}
		//console.log('data tab',data)
		if (!tab) {
			this.props.reopenTab(data);
		} else {
			this.props.reActivateTab(data);
		}
		if (this.props.reopenTabCb) {
			this.props.reopenTabCb();
		}
		// }
	}

	render() {
		const {
			agentInfo,
			CallId,
			disableOptions,
			endBusiness,
			endBusinessId,
			has_tags,
			getCalls,
			outgoingServiceCb,
			phoneNumber,
			rescheduleCallCb,
			scheduleDate,
			scheduleService,
			selectedLanguage,
			serviceId,
			translations,
			listDetailId
		} = this.props;
		const isInValidServiceId = serviceId === 0;
		const inValidServiceIdText = isInValidServiceId ?
			translations.disableOutGoingCallMessage[selectedLanguage] : '';


		return (
			<div>
				<div
					className={this.state.isShow ? `dropdown pull-right open a${this.props.theme}` : `dropdown pull-right a${this.props.theme}`}
					onClick={this.handleClick} >
					<a
						className="dropdown-toggle icon icon-cog tab-actions-icon btn-icon"
						data-toggle="dropdown"
						aria-haspopup="true"
						aria-expanded={this.state.isShow ? 'true' : 'false'}>
					</a>
					<ul className={`dropdown-menu dropdown-menu${this.props.theme}`}>
						{/* <li className={classnames({disabled: disableOptions})}> */}
						<li>
							<a onClick={this.reopenTab}>
								<span className="icon icon-back-in-time" />
								&nbsp;&nbsp;{translations.reopenTab[selectedLanguage]}
							</a>
						</li>
						<li role="separator" className="divider" />
						<li>
							<a onClick={() => this.open('showRescheduleCallModal')}>
								<span className="icon icon-clock" />
								&nbsp;&nbsp;{translations.rescheduleCall[selectedLanguage]}
							</a>
						</li>
						<li className={isInValidServiceId ? 'disabled' : ''} title={inValidServiceIdText}>
							<a onClick={() => this.open('showSetBusinessOutcomeModal')}>
								<span className="icon icon-archive" />
								&nbsp;&nbsp;{translations.businessOutcome[selectedLanguage]}
							</a>
						</li>
						<li className="" title={inValidServiceIdText}>
							<a onClick={() => this.open('showTagsModal')}>
								<span className="icon icon-price-tag" />
								&nbsp;&nbsp;{translations.tagList[selectedLanguage]}
							</a>
						</li>
						<li>
							<a onClick={() => this.open('showAssignToAnotherServiceModal')}>
								<span className="icon icon-popup" />
								&nbsp;&nbsp;{translations.assignToAnotherService[selectedLanguage]}
							</a>
						</li>
						{agentInfo &&
                        agentInfo.extra_data &&
                        agentInfo.extra_data.listen_recording &&
						agentInfo.extra_data.listen_recording === "1" ? (
                           <li>
                             <a
                            	onClick={() => this.open("showRecordingModal")}
                             >
                               <span>
                                 <img
								 className={`record_icon${this.props.theme}`}
                                   src={record}
                                   style={{ height: "13px", marginLeft: "4px" }}
                                 />
                               </span>
                               &nbsp;&nbsp;{translations.recording[selectedLanguage]}
                             </a>
                           </li>
                        ) : null}
					</ul>
					<RescheduleCall
						serviceId={serviceId}
						CallId={CallId}
						phoneNumber={phoneNumber}
						scheduleDate={scheduleDate}
						scheduleService={scheduleService}
						showModal={this.state.showRescheduleCallModal}
						rescheduleCallCb={rescheduleCallCb}
						handleClose={() => this.close('showRescheduleCallModal')}
						listDetailId={listDetailId}
						getCalls={getCalls}
					/>
					<SetBusinessOutcome
						serviceId={serviceId}
						CallId={CallId}
						endBusinessId={endBusinessId}
						showModal={this.state.showSetBusinessOutcomeModal}
						handleClose={() => this.close('showSetBusinessOutcomeModal')}
						outgoingServiceCb={outgoingServiceCb}
					/>
					<SetTagsModal
						serviceId={serviceId}
						CallId={CallId}
						showModal={this.state.showTagsModal}
						handleClose={() => this.close("showTagsModal")}
						getCalls={getCalls}
				    />
					<AssignToAnotherService
						serviceId={serviceId}
						CallId={CallId}
						showModal={this.state.showAssignToAnotherServiceModal}
						handleClose={() => this.close('showAssignToAnotherServiceModal')}
						getCalls={getCalls}
					/>
					<Recording
					    serviceId={serviceId}
					    CallId={CallId}
					    showModal={this.state.showRecordingModal}
					    handleClose={() => this.close('showRecordingModal')}
						recordingUrl={this.recordingUrl}
					/>
				</div>
				{disableOptions && <span title={endBusiness} className="icon icon-archive padding_right_4 pull-right" />}
				{(scheduleDate !== "") && <span
					title={moment.tz(scheduleDate * 1000, agentInfo.timezone).format('DD-MM-YYYY HH:mm')}
					className="icon icon-clock padding_right_4 pull-right"
				/>}
				{has_tags  && (					
					<span
						title={translations.containsTags[selectedLanguage]}
						className="icon icon-price-tag padding_right_4 pull-right"
					/>
				)}
			</div>
		);
	}
}

function mapStateToProps(state) {
	return {
		agentInfo: state.agentInfo,
		events: state.callEvents.events,
		closeMenu: state.common.closeMenu,
		translations: state.languages.translations,
		selectedLanguage: state.languages.selectedLanguage,
		darkMode: state.common.darkMode,
		theme: state.common.theme,
	};
}

const mapDispatchToProps = {
	reopenTab,
	reActivateTab,
	getRecording
};

export default connect(mapStateToProps, mapDispatchToProps)(enhanceWithClickOutside(CallMenu));



// WEBPACK FOOTER //
// ./src/agent/call-menu.js